import { forwardRef, HTMLAttributes, ReactNode } from 'react';

import { cn } from '@/components/ui';

export interface MainCardProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title' | 'content'> {
  children?: ReactNode;
  subheader?: ReactNode;
  content?: boolean;
  contentClassName?: string;
  darkTitle?: boolean;
  divider?: boolean;
  secondary?: ReactNode;
  title?: ReactNode;
}

const MainCard = forwardRef<HTMLDivElement, MainCardProps>(
  (
    {
      children,
      className,
      content = true,
      contentClassName,
      darkTitle,
      divider = true,
      secondary,
      subheader,
      title,
      ...others
    },
    ref,
  ) => (
    <div
      ref={ref}
      className={cn(
        'relative overflow-hidden rounded-auditor-lg border border-line bg-surface text-ink shadow-auditor',
        className,
      )}
      {...others}
    >
      {title && (
        <div className="flex items-center gap-4 p-5">
          <div className="min-w-0 flex-1">
            <div className={cn('m-0 font-semibold tracking-title', darkTitle ? 'text-lg' : 'text-base')}>{title}</div>
            {subheader && <div className="mt-1 text-sm text-ink-muted">{subheader}</div>}
          </div>
          {secondary && <div className="flex shrink-0 items-center self-center">{secondary}</div>}
        </div>
      )}
      {title && divider && <hr className="m-0 h-px w-full border-0 bg-line" />}
      {content && <div className={cn('p-5', contentClassName)}>{children}</div>}
      {!content && children}
    </div>
  ),
);

MainCard.displayName = 'MainCard';

export default MainCard;
